export default __webpack_public_path__ + "static/media/virtual_services_price_en.14168cad.png";